/* unplugin-vue-components disabled */import { render } from "./navbar-desktop.vue?vue&type=template&id=0012305e&scoped=true"
import script from "./navbar-desktop.vue?vue&type=script&lang=js"
export * from "./navbar-desktop.vue?vue&type=script&lang=js"

import "./navbar-desktop.vue?vue&type=style&index=0&id=0012305e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0012305e"],['__file',"src/components/navbar/navbar-desktop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0012305e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0012305e', __exports__)) {
    api.reload('0012305e', __exports__)
  }
  
  module.hot.accept("./navbar-desktop.vue?vue&type=template&id=0012305e&scoped=true", () => {
    api.rerender('0012305e', render)
  })

}


export default __exports__